import Modal from "react-bootstrap/Modal";
import stripe from "../../..//assets/images/stripe.png";

function StripeConnect(props) {
  const{show,handleClose}=props;

  return (
    <>
      <Modal
        show={show}
        className="modal-common client-stripe-pop"
        onHide={handleClose}
      >
        <Modal.Body>
          <div className="text-center">
            <div className="d-flex justify-content-center align-items-center">
              <img alt="" src={stripe} />
            </div>
            <h2 className="mb-3 mt-4 fw-bold">Connect to Stripe</h2>
            <p className="mb-3">Please connect your stripe account</p>
            <button className="btn d-inline-block btn-primary modal-blue-btn text-capitalize w-100 text-white"
            >Connect </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default StripeConnect;
